import * as React from 'react';
import { DocumentationLinkProps } from '../DocumentationLink';
import PageHeaderButtons from '../PageHeaderButtons';
import styles from './style.m.less';

type Props = {
    title?: React.ReactNode;
    children?: React.ReactNode;
    documentation?: DocumentationLinkProps;
};

function PageHeader({ title, documentation, children }: Props) {
    return (
        <header className={styles.header}>
            <h1 className={styles.heading}>{title}</h1>
            {(children || documentation) && (
                <PageHeaderButtons documentation={documentation}>{children}</PageHeaderButtons>
            )}
        </header>
    );
}

export default PageHeader;
